module.exports = __webpack_public_path__ + "img/ic-pay.4427c5e5.svg";